export default "__VITE_ASSET__57b7ea5e__"